import React from "react";

import {Button} from "@pg-design/button-module";
import {ConstructionHelmetIcon} from "@pg-design/icons-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {OfferDetailBrandButtonStyle} from "../atoms/OfferNavBar";

interface Props {
    onButtonClick: () => void;
}

export const DetailConstructionGalleryCTA = (props: Props) => {
    const {isMobile} = useUserDevice();
    return (
        <Button
            css={OfferDetailBrandButtonStyle}
            iconLeft={ConstructionHelmetIcon}
            variant="brand_icon"
            size={isMobile ? "medium" : "big"}
            onClick={() => {
                props.onButtonClick();
            }}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_CONSTRUCTION_GALLERY_BUTTON}
        >
            Zdjęcia z budowy
        </Button>
    );
};
import React from "react";

import {Button} from "@pg-design/button-module";
import {ConstructionHelmetIcon} from "@pg-design/icons-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {OfferDetailBrandButtonStyle} from "../atoms/OfferNavBar";

interface Props {
    onButtonClick: () => void;
}

export const DetailConstructionGalleryCTA = (props: Props) => {
    const {isMobile} = useUserDevice();
    return (
        <Button
            css={OfferDetailBrandButtonStyle}
            iconLeft={ConstructionHelmetIcon}
            variant="brand_icon"
            size={isMobile ? "medium" : "big"}
            onClick={() => {
                props.onButtonClick();
            }}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_CONSTRUCTION_GALLERY_BUTTON}
        >
            Zdjęcia z budowy
        </Button>
    );
};
